import React, { useContext } from 'react';
import { RestaurantsContext, IRestaurantsContext } from '../../../restaurantsState/restaurantsContext';
import SearchField from 'components/SearchField/SearchField';

const Search: React.FC = () => {
	const { changeSearchString, searchString, restaurants } = useContext<IRestaurantsContext>(RestaurantsContext);

	return (
		<SearchField
			onChangeSelectSearchString={changeSearchString}
			searchString={searchString}
			delay={restaurants.restaurantCount ? 800 : undefined}
		/>
	);
};

export default Search;
